import { allSvgs } from "./importAllSvgImageFiles";
export function AllSvgImageFiles() {
    return (<div style={{ paddingLeft: "1rem" }}>
            <p>This is the complete set of all *.svg image files in the portal package. Note that this excludes any images from the design system.</p>
            <AllImages />
        </div>);
}
function AllImages() {
    return (<>
            {Object.keys(allSvgs).map((svgName) => (
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        <SvgImage svgName={svgName} svgPath={allSvgs[svgName] as string}/>))}
        </>);
}
function SvgImage({ svgName, svgPath }: {
    svgName: string;
    svgPath: string;
}) {
    return (<>
            <h2>{svgName}</h2>
            <div style={{ paddingLeft: "1rem" }}>
                <img style={{ maxHeight: "500px", maxWidth: "500px" }} src={svgPath} alt={svgName}/>
            </div>
        </>);
}
